module.exports = __webpack_public_path__ + "interactiveApp/KurzByk/media/12 Zebro vysoke 1.jpg";